import { resolveBackendMediaUrl } from '../api';

function catalogAttachmentUrl(mediaId: number, url?: string): string {
  const resolved = url ? resolveBackendMediaUrl(url) : '';
  if (resolved.includes('/api/media/catalog/')) {
    return `${resolved.split('?')[0]}?download=1`;
  }
  const proxy = resolveBackendMediaUrl(`/api/media/catalog/${mediaId}`);
  return `${proxy.split('?')[0]}?download=1`;
}

/** Telegram WebView не умеет blob: — открываем attachment-URL во внешнем браузере или вкладке. */
function openMediaDownloadUrl(downloadUrl: string): void {
  const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined;
  if (tg?.openLink) {
    tg.openLink(downloadUrl, { try_instant_view: false });
    return;
  }
  const a = document.createElement('a');
  a.href = downloadUrl;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/** Скачать медиафайл с бэкенда (админка: ПК и Telegram через внешний браузер). */
export async function downloadBackendMediaFile(
  url: string,
  opts?: { mediaId?: number; kind?: 'video' | 'image'; filename?: string },
): Promise<void> {
  const mediaId = opts?.mediaId;
  if (mediaId != null && mediaId > 0) {
    openMediaDownloadUrl(catalogAttachmentUrl(mediaId, url));
    return;
  }

  const resolved = resolveBackendMediaUrl(url);
  if (!resolved) throw new Error('empty url');

  const withDownload = resolved.includes('?') ? `${resolved}&download=1` : `${resolved}?download=1`;
  openMediaDownloadUrl(withDownload);
}
